<template>
  <b-modal v-model="isActive" has-modal-card trap-focus :width="720" @close="close">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button type="button" class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <b-table :data="errors" striped narrowed>
          <template slot="empty">
            <p class="has-text-centered py-4">No hay errores registrados</p>
          </template>
          <b-table-column field="at" label="Fecha" v-slot="props">
            {{ formatAt(props.row.at) }}
          </b-table-column>
          <b-table-column field="code" label="Código" v-slot="props">
            {{ props.row.code || '—' }}
          </b-table-column>
          <b-table-column field="source" label="Origen" v-slot="props">
            {{ props.row.source === 'send' ? 'Envío de lote' : 'Escaneo' }}
          </b-table-column>
          <b-table-column field="message" label="Detalle" v-slot="props">
            {{ props.row.message }}
          </b-table-column>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <button type="button" class="button" @click="close">Cerrar</button>
        <button type="button" class="button is-danger is-light" @click="clear">Limpiar errores</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ScanErrorsModal',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Detalle de errores'
    }
  },
  data() {
    return {
      isActive: this.active
    };
  },
  watch: {
    active(val) {
      this.isActive = val;
    },
    isActive(val) {
      if (!val) {
        this.$emit('close');
      }
    }
  },
  methods: {
    formatAt(value) {
      if (!value) {
        return '—';
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return value;
      }
      const pad = (n) => (n < 10 ? '0' + n : '' + n);
      return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear()
          + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
    },
    close() {
      this.isActive = false;
      this.$emit('close');
    },
    clear() {
      this.$emit('clear');
    }
  }
};
</script>
